import { Check, Columns3 } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/** Which columns the register shows. The choice is this officer's own and is remembered. */
export const ColumnPicker = ({ columns, shown, onToggle, onReset, testId = "column-picker" }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        data-testid={testId}
        className="flex h-11 items-center gap-2 border border-border bg-card px-4 font-display text-[10px] font-bold uppercase tracking-widest transition-colors duration-200 hover:bg-muted"
      >
        <Columns3 className="h-3.5 w-3.5" /> Columns · {shown.length}
      </button>
    </PopoverTrigger>
    <PopoverContent align="end" className="max-h-80 w-64 overflow-y-auto rounded-none bg-popover p-0">
      <div className="flex items-center justify-between border-b border-border px-3 py-2">
        <div className="label-caps">Columns</div>
        <button
          type="button"
          data-testid={`${testId}-reset`}
          onClick={onReset}
          className="text-[10px] underline decoration-dotted text-muted-foreground transition-colors duration-200 hover:text-foreground"
        >
          Reset
        </button>
      </div>
      {columns.map((c) => {
        const on = shown.includes(c.key);
        return (
          <button
            key={c.key}
            type="button"
            data-testid={`${testId}-${c.key}`}
            onClick={() => onToggle(c.key)}
            className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm transition-colors duration-200 hover:bg-muted"
          >
            <span
              className={`flex h-4 w-4 shrink-0 items-center justify-center border ${
                on ? "border-primary bg-primary text-primary-foreground" : "border-border"
              }`}
            >
              {on && <Check className="h-3 w-3" />}
            </span>
            <span className={on ? "font-semibold" : "text-muted-foreground"}>{c.label}</span>
          </button>
        );
      })}
    </PopoverContent>
  </Popover>
);
